import React from 'react';
import StudentList from './StudentList';
import { FiUserCheck } from 'react-icons/fi';


const AdminActiveStudents = () => {
  return (
    <StudentList
      title="Active Students"
      filterStatus="active"
       icon={<FiUserCheck color="#2e7d32" />}  // green check icon
      // onAdd={() => console.log('Add student modal open')}
    />
  );
};

export default AdminActiveStudents;
